const COMPONENT_SELECTOR = '[data-real-complementary-surface]';
const LINE_ITEM_PROPERTY_NAME = 'properties[_real_complementary]';

/** @type {'cart_drawer' | 'product_page' | 'main_cart' | null} */
let modalSurface = null;
let modalBoardOfferEligible = false;

/**
 * @param {Element} element
 * @returns {'cart_drawer' | 'product_page' | 'main_cart' | null}
 */
function getSurface(element) {
  const component = element.closest(COMPONENT_SELECTOR);
  if (!(component instanceof HTMLElement)) return null;

  const surface = component.dataset.realComplementarySurface;
  return surface === 'cart_drawer' || surface === 'product_page' || surface === 'main_cart' ? surface : null;
}

/**
 * @param {HTMLFormElement} form
 * @param {'cart_drawer' | 'product_page' | 'main_cart' | null} surface
 */
function updateLineItemProperty(form, surface) {
  let propertyInput = form.querySelector(`input[name="${LINE_ITEM_PROPERTY_NAME}"]`);

  if (!surface) {
    propertyInput?.remove();
    return;
  }

  if (!(propertyInput instanceof HTMLInputElement)) {
    propertyInput = document.createElement('input');
    propertyInput.type = 'hidden';
    propertyInput.name = LINE_ITEM_PROPERTY_NAME;
    form.append(propertyInput);
  }

  if (propertyInput.value !== surface) propertyInput.value = surface;
}

function prepareQuickAddDialog() {
  const modalContent = document.getElementById('quick-add-modal-content');
  if (!(modalContent instanceof HTMLElement)) return;

  const form = modalContent.querySelector('form[action*="/cart/add"]');
  if (form instanceof HTMLFormElement) updateLineItemProperty(form, modalSurface);

  // Liquid owns the offer amount. Horizon replaces this container after each
  // variant response, so its template always belongs to the current variant.
  for (const container of modalContent.querySelectorAll('product-price [ref="priceContainer"]')) {
    const template = container.querySelector('template[data-real-cart-offer]');
    let offer = container.querySelector('.real-cart-quick-add-offer');
    const showOffer =
      modalSurface === 'cart_drawer' &&
      modalBoardOfferEligible &&
      template instanceof HTMLTemplateElement &&
      template.content.childElementCount > 0;

    if (!showOffer) {
      offer?.remove();
      container.removeAttribute('data-real-cart-offer-active');
      continue;
    }

    // Retain the native price nodes for ordinary origins and dialog cleanup.
    // Repeated observer delivery must not create more DOM mutations or clones.
    if (offer && offer.getAttribute('data-real-cart-offer-template') !== template.id) {
      offer.remove();
      offer = null;
    }
    if (!offer) {
      const renderedOffer = document.createElement('div');
      renderedOffer.className = 'real-cart-quick-add-offer';
      renderedOffer.dataset.realCartOfferTemplate = template.id;
      renderedOffer.append(template.content.cloneNode(true));
      container.append(renderedOffer);
    }
    if (!container.hasAttribute('data-real-cart-offer-active')) {
      container.setAttribute('data-real-cart-offer-active', '');
    }
  }
}

/** @param {MouseEvent} event */
function handleClick(event) {
  if (!(event.target instanceof Element)) return;

  const chooseButton = event.target.closest('.quick-add__button--choose');
  if (!(chooseButton instanceof HTMLButtonElement)) return;

  // Horizon reuses one Quick Add dialog for complementary and standard cards.
  // A standard card must clear any attribution left by the previous dialog.
  modalSurface = getSurface(chooseButton);
  const component = chooseButton.closest(COMPONENT_SELECTOR);
  modalBoardOfferEligible =
    modalSurface === 'cart_drawer' &&
    component instanceof HTMLElement &&
    component.dataset.realCartOfferEligible === 'true';
  prepareQuickAddDialog();
}

document.addEventListener('click', handleClick, { capture: true });

const quickAddDialog = document.getElementById('quick-add-dialog');
const quickAddModalContent = document.getElementById('quick-add-modal-content');

quickAddDialog?.addEventListener('dialog:open', prepareQuickAddDialog);

quickAddDialog?.addEventListener('dialog:close', () => {
  modalSurface = null;
  modalBoardOfferEligible = false;
  prepareQuickAddDialog();
});

if (quickAddModalContent) {
  new MutationObserver(prepareQuickAddDialog).observe(quickAddModalContent, {
    childList: true,
    subtree: true,
  });
}
